export default __webpack_public_path__ + "static/media/meeting3.6cd0729c.svg";